<mojo-viewbar></mojo-viewbar>
<mojo-page-title [title]="pageTitle$ | async"></mojo-page-title>


<section class="mojo-admin-page panel data-table full-page-widget full-page-scrollable">
  <div class="panel-body">
    <mojo-profile-table [profiles]="profiles$ | async" [loading]="loading$ | async"
                        (onRowClicked)="profileSelected($event)"></mojo-profile-table>
  </div>
  <p-footer>
    <div class="table-button-section ui-helper-clearfix">
      <button class="add-profile-button" type="button" pButton icon="fa-fw fa fa-plus" (click)="showDialogToAdd()"
              label="Add"></button>
      <button type="button" pButton [routerLink]="[getDashboardDesignerPath()]" icon="fa-fw fa fa-paint-brush"
              label="Dashboard Designer"></button>
    </div>
  </p-footer>
</section>

<mojo-profile-editor [widgetConfigurations]="widgetConfigurations$ | async" [dialogTitle]="dialogTitle"
                     (onSaveComplete)="loadProfiles()" (onDeleted)="loadProfiles()"></mojo-profile-editor>

